/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IAsset, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

export class TombstoneGameAssets {

    public static INTRO_BACKGROUND:string = "introBackground";
    public static INTRO_LOGO:string = "introLogo";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static REELS_BACKGROUND:string = "reelsBackground";
    public static MAIN_GAME_FOREGROUND:string = "mainForeground";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(TombstoneGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static getSymbolWinStateTexture(symbolName:string):PIXI.Texture[] {
        if(symbolName.indexOf("B") > -1) {
            return GameResources.getTextures(`${symbolName}/${symbolName}_Win/${symbolName}_Win`);
        }
        return GameResources.getTextures(`${symbolName}/${symbolName}_Win/${symbolName}_Win_`);
    }

    public static getSymbolAttentionStateTexture(symbolName:string):PIXI.Texture[] {
        if(symbolName.indexOf("B") > -1) {
            return GameResources.getTextures(`${symbolName}/${symbolName}_Attention/${symbolName}_Attention`);
        }
        return GameResources.getTextures(`${symbolName}/${symbolName}_Attention/${symbolName}_Attention_`);
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("NumbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json"),
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                ],
                animations : {
                    "introLogo" : "introLogo",
                    "introFeature1" : "Features_1",
                    "introFeature2" : "Features_2",
                    "introFeature3" : "Features_3",
                    "introBackground" : "introBackground"
                }
            }
        ],



        main : [
            {
                name : "spine",
                assets : [
                   new SpineAsset("capWin", "spine/capwin.json")
                ]
            },
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("NumbersTombstone", "fonts/bitmapfonts/NumbersTombstone.fnt"),
                    new BitmapFontAsset("Multipliers", "fonts/bitmapfonts/Multipliers.fnt")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json")
                ],
                animations : {
                    "mainBackground" : "mainBackground",
                    "reelsBackground" : "ReelBackground",
                    "mainForeground" : "Reel_Foreground",
                    "wildJailRespin" : "WildJail/WildJail/WildJail_",
                    "wildJailSuperFS" : "WildJail/WildJailWindow/WildJailWindow_",
                    "multiplierBg" : "multiplierAttention/MultiplierAttention_",
                    "bigWinCoin0" : "bigwin/coinCopper/coinCopper_",
                    "bigWinCoin1" : "bigwin/coinSilver/CoinSilver_",
                    "bigWinCoin2" : "bigwin/coinGold/CoinGold_",
                    "bigWinText0" : "bigwin/theGood",
                    "bigWinText1" : "bigwin/theBad",
                    "bigWinText2" : "bigwin/theUgly",
                    "bigWinRays" : "RaysBigWin/RaysBigWin_",
                    "sparkSmoke" : "SparkSmoke/SparkSmoke_",
                    "holeSmoke" : "smokeHole-HALF/SmokeHoleHalf_",
                    "toggle" : "individualwin/toggle/ToggleAnimation_",
                    "toggleW" : "individualwin/ToggleW/ToggleW_",
                    "respinIntro3" : "3RespinsIntro/3text",
                    "justiceSpins" : "3RespinsIntro/JusticeSpins/JusticeSpins_",
                    "freespinIntro10" : "freespinintro/10text",
                    "freespinIntro12" : "freespinintro/12text",
                    "introTextGunslinger" : "freespinintro/FS_intro_GunslingerTEXT/GunslingerText_",
                    "introTextBounty" : "freespinintro/FS_intro_BountyTEXT/BountyText_",
                    "introTextSpins" : "freespinintro/FS_intro_SpinsTEXT/SpinsText_",
                    "badLuck" : "freespinoutro/badluck",
                    "FS+1" : "freespinretrigger/+1FS",
                    "FS+2" : "freespinretrigger/+2FS",
                    "noJustice" : "justiceoutro/NoJustice",
                    "reelAttention" : "ReelAttention/ReelAttention_",

                    "bulletHole" : "shoot/BulletHole",
                    "bulletHole_spin" : "shoot/BulletHole_spin",

                    "tumbleWeed" : "TumbleWeedSmall/TumbleWeed_",
                    "gecko" : "gecko/gecko",
                    "wind" : "wind2/wind2_",

                    "windowHole" : "shoot/HoleWindow",
                }
            },
            {
                name : "mainHigh",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHigh0", "sheets/mainHigh/mainHigh0.json"),
                    new TextureAsset("mainHigh1", "sheets/mainHigh/mainHigh1.json")
                ],
                animations : {
                    "logo" : "LOGO",
                    "108winWays" : "WinWaysSigns/108WinWays",
                    "waysWonPlate" : "WinWaysSigns/WaysWonSignEmpty",
                    "waysWonText" : "WinWaysSigns/WaysWonText",
                    "wayWonText" : "WinWaysSigns/WayWonText"
                }
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),
                    new TextureAsset("symbols2", "sheets/symbols/symbols2.json"),
                    new TextureAsset("symbols3", "sheets/symbols/symbols3.json")
                ],
                animations : {
                    "wildMulti" : "W/W_x",
                    "wildMulti_spin" : "W/W_spin_x",
                    "busted" : "W/busted",
                    "busted_spin" : "W/busted_spin"
                }
            }
        ]
    };
}